import { render, staticRenderFns } from "./SeparateInputs.vue?vue&type=template&id=2f1efe75&scoped=true"
import script from "./SeparateInputs.vue?vue&type=script&lang=js"
export * from "./SeparateInputs.vue?vue&type=script&lang=js"
import style0 from "./SeparateInputs.vue?vue&type=style&index=0&id=2f1efe75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1efe75",
  null
  
)

export default component.exports